import { useMemo, FC } from 'react';
import { DATE_INTERVAL_SELECT_ITEM_CLASS } from '../constants';
import IDateIntervalSelectItemProps from '../models/date-interval-select-item.props';

const DateIntervalSelectItem: FC<IDateIntervalSelectItemProps> = ({
  label,
  value,
  icon,
  first,
  last,
  active,
  onItemClick
}) => {
  const customClasses = useMemo(() => {
    let classes = '';
    if (active) {
      classes += ` ${DATE_INTERVAL_SELECT_ITEM_CLASS}--active`;
    }
    if (icon) {
      classes += ` g-icon-${icon}`;
    }
    if (first) {
      return classes += ` ${DATE_INTERVAL_SELECT_ITEM_CLASS}--first`;
    }
    if (last) {
      return classes += ` ${DATE_INTERVAL_SELECT_ITEM_CLASS}--last`;
    }
    return classes;
  }, [first, last, active, icon]);

  const handleClick = () => onItemClick(value);

  return (
    <li className={`${DATE_INTERVAL_SELECT_ITEM_CLASS}${customClasses}`} onClick={handleClick}>
      {!icon ? label : null}
    </li>
  );
};

export default DateIntervalSelectItem;